import { updates } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const typeStyle: Record<string, string> = {
  同步: "bg-primary-100 text-primary-700",
  优化: "bg-secondary-100 text-secondary-700",
  公告: "bg-accent-100 text-accent-800",
  功能: "bg-background-200 text-foreground-700",
};

export default function Updates() {
  return (
    <section id="updates" className="bg-background-100/70">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.1fr_1fr] lg:gap-16">
        {/* 左侧公告 */}
        <div>
          <SectionHeading
            eyebrow="站内公告"
            title="更新与入口变化一目了然"
            desc="防屏蔽、换新网址、功能升级都会在这里留痕，可回溯可查证，入口变动不再神神秘秘。"
          />
          <div className="mt-8 flex flex-col gap-0">
            {updates.map((u, i) => (
              <div key={u.title} className="relative flex gap-4 pb-8 last:pb-0">
                {i < updates.length - 1 && (
                  <span className="absolute left-[11px] top-7 h-full w-px bg-background-200"></span>
                )}
                <span
                  className={`relative mt-0.5 h-[23px] w-[23px] shrink-0 rounded-full border-4 border-background-100 ${
                    i === 0 ? "bg-accent-500" : "bg-background-300"
                  }`}
                ></span>
                <div className="flex-1 rounded-xl border border-background-200/80 bg-background-50 p-4">
                  <div className="flex flex-wrap items-center gap-2.5">
                    <span className="text-xs font-medium text-foreground-500">{u.date}</span>
                    <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${typeStyle[u.type] ?? typeStyle["功能"]}`}>
                      {u.type}
                    </span>
                    <h3 className="text-[15px] font-semibold text-foreground-950">{u.title}</h3>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{u.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 右侧：更新提醒订阅 CTA */}
        <div className="lg:pt-24">
          <div className="flex h-full flex-col justify-center overflow-hidden rounded-2xl border border-primary-200/70 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50/70 p-7 md:p-8">
            <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-notification-3-line text-[13px]"></i>
              开启防屏蔽更新提醒
            </span>
            <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              下次换新网址，
              <br />
              第一时间通知你
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              订阅后可选择接收新网址、屏蔽预警或每周汇总。实时同步、防走丢、防屏蔽，全程不留死角，不错过任何新内容。
            </p>
            <div className="mt-6 flex flex-col gap-2.5">
              <button
                type="button"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-notification-4-line mr-2 text-lg"></i>
                开启提醒（演示）
              </button>
              <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-checkbox-circle-line text-accent-600"></i>
                  免费
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-checkbox-circle-line text-accent-600"></i>
                  随时可关
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-checkbox-circle-line text-accent-600"></i>
                  多入口覆盖
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}